export const browserChecker = {
  is_iOS: () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  }
}

export default browserChecker;


// WEBPACK FOOTER //
// ./src/utils/browserChecker.ts